import React from 'react';
import './App.css';
import { Outlet } from "react-router-dom";
import Header from "./Components/Header"
import MainRoutes from "./Components/MainRoutes"
import { Language, dictionaryList } from "./languages"
import { LanguageContext, Complexity, RateCard, ComplexityOverride, RateCardOverride } from "./Helpers/Context"
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import Typography from '@material-ui/core/Typography';

require('./Helpers/api')

function App() {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang');

  useMsalAuthentication(InteractionType.Redirect);

  const [language, setLanguage] = useState(lang === "fr" ? Language.French : Language.English);
  const [complexity, setComplexity] = useState<Complexity>();
  const [complexityOverride, setComplexityOverride] = useState<ComplexityOverride>();
  const [rateCard, setRateCard] = useState<RateCard>();
  const [rateCardOverride, setRateCardOverride] = useState<RateCardOverride>();
  const [officeId, setOfficeId] = useState(0);

  const setComplexityContext = function (item: Complexity) {
    setComplexity(item);
    setRateCard(undefined);
  }

  const setLanguageContext = function (lang: Language) {
    setLanguage(lang);
  }

  return (
    <LanguageContext.Provider value={{
      language,
      setLanguage: (value) => setLanguageContext(value),
      dictionary: dictionaryList[language],
      complexity: complexity,
      setComplexity: (value) => setComplexityContext(value),
      rateCard: rateCard,
      setRateCard: (value) => setRateCard(value),
      officeId: officeId,
      setOfficeId: (value) => setOfficeId(value),
      complexityOverride: complexityOverride,
      setComplexityOverride: (value) => setComplexityOverride(value),
      rateCardOverride: rateCardOverride,
      setRateCardOverride: (value) => setRateCardOverride(value),
    }}>
      <div className="App">
        <Header />
        <AuthenticatedTemplate>
          {officeId === 0
            ?
            <Typography variant="h6" >
              {dictionaryList[language].selectAnOffice}
            </Typography>
            :
            <React.Fragment>
              <MainRoutes />
              <Outlet />
            </React.Fragment>
          }
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Typography variant="h6" >
            {dictionaryList[language].pleaseSignIn}
          </Typography>
        </UnauthenticatedTemplate>
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
